import { graphql, HttpResponse } from 'msw';
import type {
  PostFanSuperMessageByRegisteredCreditCardMutation,
  PostFanSuperMessageByRegisteredCreditCardMutationVariables,
} from '@/__generated__/graphql';

export const postFanSuperMessageByRegisteredCreditCard = graphql.mutation<
  PostFanSuperMessageByRegisteredCreditCardMutation,
  PostFanSuperMessageByRegisteredCreditCardMutationVariables
>('PostFanSuperMessageByRegisteredCreditCard', ({ variables }) => {
  const { input } = variables;

  return HttpResponse.json({
    data: {
      __typename: 'Mutation',
      postFanSuperMessageByRegisteredCreditCard: {
        __typename: 'PostFanSuperMessageByCreditCardPayloadSuccess',
        redirectUrl: `${input.callbackUrl}?p=eyJhY2Nlc3NJZCI6IjQzYjI3M2U3OTdhMjJlZmMwZDNlYjY4MGY2ZGFkMWU0IiwiZXZlbnQiOiJURFNfRklOSVNIRUQiLCJjc3JmVG9rZW4iOm51bGx9`,
        ok: true,
      },
    },
  });
});
